/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */
define(['jquery', 'assets/js/modules/View', 'scrolltofixed/jquery-scrolltofixed-min'], function($, View) {
    return View.extend({
        initialize: function(options) {
            var $headers = options.headers;

            var additionalMargin = options.additionalMargin || 0;
            var marginTop = this.getFixedHeaderHeight() + additionalMargin;
            var zIndex = options.zIndex || this.ZINDEX_NAVBAR;

            var pluginOptions = {
                marginTop: marginTop,
                zIndex: zIndex,
                preFixed: options.preFixed || null,
                postFixed: options.postFixed || null,
                limit: options.limit || null,
                spacerClass: options.spacerClass || null
            };

            if (options.bottom !== undefined) {
                pluginOptions.bottom = options.bottom;
            }

            $headers.each(function() {
                $(this).scrollToFixed(pluginOptions);
            });
        }
    });
});
